import React from 'react';
import { Elements, StripeProvider } from 'react-stripe-elements';
import { importExternalScript } from '../../../services/ExternalScriptImporter';
import { getStripeScriptLocation, getStripeKey } from '../../../utils/env/billingEnv';


const fonts = [{ cssSrc: 'https://fonts.googleapis.com/css?family=Lato:100,100i,300,300i,400,400i,700,700i,900,900i' }];

class BillingStripeWrapper extends React.Component {

    constructor(props) {
        super(props);
        this.isDestroyed = false;
        this.state = {
            isStripeLoaded: false,
        };
        importExternalScript(getStripeScriptLocation())
            .then(() => {
                if (!this.isDestroyed) {
                    this.setState({ isStripeLoaded: true });
                }
            });
    }

    componentWillUnmount() {
        this.isDestroyed = true;
    }

    render() {
        const {
            children
        } = this.props;

        return (
            this.state.isStripeLoaded ?
                <StripeProvider apiKey={getStripeKey()}>
                    <Elements fonts={fonts} locale="en">
                        {children}
                    </Elements>
                </StripeProvider> :
                <React.Fragment></React.Fragment>
        );
    }
}

export default BillingStripeWrapper;
